<template>
  <div ref="fullscreenContainer" class="text-center containerTv" @click="toggleFullScreen">
    <div class="card p-0 shadow-lg" style="background-color: #f8f9fa;">
      <div class="row">
        <div class="col-md-6 p-0 mb-0">
          <carousel :showControls="false" :slides="slidesData"></carousel>
        </div>

        <!-- Senha Atual e Relógio -->
        <div class="col-md-6 p-0 mb-0">
          <div class="chamada-card">
            <h1 class="title-primary font-weight-bold p-2">SENHA</h1>
            <div class="display-1 font-weight-bold text-dark destaque">{{ currentPassword }}</div>
            <span class="title-primary font-weight-bold">MESA</span>
            <span class="destaque text-dark font-weight-bold">{{ currentTable }}</span>
            <h1 class="title-primary font-weight-bold">DATA</h1>
            <span class="destaque text-dark">{{ currentDate }}</span>
            <h5 class="clock p-2 text-center">
              <span class="hours">{{ currentTime.split(':')[0] }}</span>:
              <span class="minutes">{{ currentTime.split(':')[1] }}</span>:
              <span class="seconds">{{ currentTime.split(':')[2] }}</span>
            </h5>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Últimos Chamados -->
        <div class="col-md-12 p-0 mb-0">
          <div class="card">
            <h1 class="title font-weight-bold p-2">ÚLTIMOS CHAMADOS</h1>
            <div class="row last-passwords py-3" v-for="(password, index) in lastPasswords" :key="index">
              <div class="col-4 text-center">
                <h4 class="title">SENHA</h4>
                <span class="font-weight-bold text-dark text">{{ password.number }}</span>
              </div>
              <div class="col-4 text-center">
                <h4 class="title">MESA</h4>
                <span class="font-weight-bold text-dark text">{{ password.table }}</span>
              </div>
              <div class="col-4 text-center">
                <h2 class="title">TIPO ATENDIMENTO</h2>
                <span class="font-weight-bold text-dark text">{{ password.type }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from './components/Carousel.vue'
import FilaAtendimentoRepository from '@/shared/http/repositories/nxSenhas/fila.js'
import UserRepository from '@/shared/http/repositories/nxSenhas/usuario.js'
import decodeJwt from '@/shared/utils/decodeJwt'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'Tv',
  components: {
    Carousel
  },
  data () {
    return {
      currentTable: '--',
      currentType: '--',
      slidesData: [],
      currentDate: new Date().toLocaleDateString('pt-BR'),
      currentTime: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
      isFullScreen: false,
      atendimentos: [],
      currentPassword: '--',
      lastPasswords: []
    }
  },
  created () {
    const decoded = decodeJwt()
    if (decoded) {
      this.userId = decoded.userId || decoded.id || null
      if (this.userId) {
        UserRepository.GetById(this.userId).then(response => {
          if (response.data.midias && Array.isArray(response.data.midias)) {
            // Formatar as mídias para o Carousel
            this.slidesData = response.data.midias.map(media => ({
              type: 'iframe', // Sempre tratar como iframe para URLs
              src: media, // URL da mídia
              alt: 'Conteúdo do Carousel' // Texto alternativo
            }))
          }
        })
      }
    }
  },
  methods: {
    updateTime () {
      this.currentTime = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
    },
    toggleFullScreen () {
      if (!document.fullscreenElement) {
        this.$refs.fullscreenContainer.requestFullscreen()
        this.isFullScreen = true
      } else {
        document.exitFullscreen()
        this.isFullScreen = false
      }
    },
    async fetchHistorico () {
      try {
        const response = await FilaAtendimentoRepository.GetUltimosChamados()
        this.atendimentos = response.data
        console.log('Atendimentos recebidos:', this.atendimentos)

        const atendimentoAtual = this.atendimentos.find(atendimento => atendimento.status === 'EM_ATENDIMENTO')
        if (atendimentoAtual) {
          this.currentPassword = atendimentoAtual.senhaAtendimento

          // PEGA A PRIMEIRA MESA DO usuarioAtendente
          const mesas = atendimentoAtual.usuarioAtendente.mesas || []
          this.currentTable = mesas.length > 0 ? mesas[0].nome : '--'
        } else {
          this.currentPassword = '--'
          this.currentTable = '--'
        }

        // Últimos chamados (filtra os que não estão em atendimento)
        const ultimosChamados = this.atendimentos
          .filter(atendimento => atendimento.status !== 'EM_ATENDIMENTO')
          .map(atendimento => {
            const mesas = atendimento.usuarioAtendente.mesas || []
            return {
              number: atendimento.senhaAtendimento,
              table: mesas.length > 0 ? mesas[0].nome : '--',
              type: atendimento.tipoAtendimento
            }
          })

        this.lastPasswords = ultimosChamados.slice(0, 3)
      } catch (error) {
        console.error('Erro ao buscar histórico de senhas:', error)
      }
    },
    connectWebSocket () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`, null, {
        heartbeat: [30000, 30000]
      })
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, () => {
        console.log('WebSocket conectado')

        this.stompClient.subscribe('/topic/ultimos-chamados', (mensagem) => {
          console.log('Mensagem recebida na TV:', mensagem.body)
          this.fetchHistorico()
        })
      }, (error) => {
        console.error('Erro WebSocket:', error)
      })
    }
  },
  mounted () {
    this.fetchHistorico()
    this.connectWebSocket()

    document.addEventListener('fullscreenchange', () => {
      this.isFullScreen = !!document.fullscreenElement
    })

    this.clockInterval = setInterval(this.updateTime, 1000)
  },
  beforeDestroy () {
    clearInterval(this.clockInterval)
    clearInterval(this.fetchInterval)
  }
}
</script>

<style scoped>
.containerTv {
  min-height: auto;
  min-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  pointer-events: auto;
}
.card {
  min-height: auto;
  min-width: 100%;
  border: none;
  box-shadow: none;
}
.chamada-card {
  background-color: #f8f9fa;
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.last-passwords {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 10px 0;
  margin-bottom: 10px;
}
.clock {
  font-family: 'Orbitron', sans-serif;
  font-size: clamp(1rem, 3vw, 3rem);
  font-weight: bold;
  color: #343a40;
}
.destaque {
  font-size: clamp(1.1rem, 2.5vw, 2.5rem);
}
.title-primary {
  color: #04a791;
  font-size: clamp(1.2rem, 3.5vw, 3rem);
}
.title {
  font-size: clamp(1rem, 2.5vw, 2.5rem);
  color: #04a791;
}
.text {
  font-size: clamp(0.9rem, 1.5vw, 2rem);
}
.clock span {
  transition: all 0.2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/views/private/nxSenhas/tv/tv.vue